import { useMemo } from 'react'

import { getThumbnailUrl } from '../../../../../utils/getThumbnailUrl'
import { OrganizationsTableAccessor } from '../enums/OrganizationsTableAccessor'
import { UserOrganization } from '../types/Organizations'
import { OrganizationsTableRow } from '../types/OrganizationsTableRow'

const iconSrc = (iconUrl: string | null) => (iconUrl ? getThumbnailUrl(iconUrl) : undefined)

export const useOrganizationsTableData: (organizations: UserOrganization[]) => OrganizationsTableRow[] = (
  organizations,
) => {
  return useMemo(
    () =>
      organizations.map(({ organizationId, name, iconUrl, registrationNo, url }): OrganizationsTableRow => {
        return {
          id: organizationId,
          [OrganizationsTableAccessor.Name]: name,
          [OrganizationsTableAccessor.Icon]: iconSrc(iconUrl),
          [OrganizationsTableAccessor.TaxId]: registrationNo,
          [OrganizationsTableAccessor.Url]: url,
        }
      }),
    [organizations],
  )
}
